import { ChapterDetails } from './ChapterDetails';

export default ChapterDetails;
